import { useSelector } from 'react-redux'

import MarkdownReader from '@/components/MarkdownReader'
import { isMarketplaceSelector } from '@/selectors'
import { translate } from '@/utils/translations'

import PurchaseDatePolicy from './PurchaseDatePolicy'

const TRANSLATION_KEY = 'return_policy.modal.print_rules'

const RegularStoreContentPrint = () => {
  const isMarketplace = useSelector(isMarketplaceSelector)

  if (isMarketplace) {
    return (
      <>
        <MarkdownReader>
          {translate(`${TRANSLATION_KEY}.subtitle_marketplace`)}
        </MarkdownReader>
        <ul>
          <li>
            <p>
              {translate(
                `${TRANSLATION_KEY}.marketplace_contact_seller_policy`
              )}
            </p>
          </li>
          <li>
            <p>{translate(`${TRANSLATION_KEY}.marketplace_alibris_policy`)}</p>
          </li>
        </ul>
      </>
    )
  }

  return (
    <>
      <p>{translate(`${TRANSLATION_KEY}.subtitle`)}</p>
      <ul>
        <li>
          <p>{translate(`${TRANSLATION_KEY}.not_marketplace_policy`)}</p>
        </li>
        <PurchaseDatePolicy />
        <li>
          <p>{translate(`${TRANSLATION_KEY}.not_returnable_policy`)}</p>
        </li>
        <li>
          <p>{translate(`${TRANSLATION_KEY}.consumable_item_policy`)}</p>
        </li>
        <li>
          <p>{translate(`${TRANSLATION_KEY}.original_condition_policy`)}</p>
        </li>
        <li>
          <p>{translate(`${TRANSLATION_KEY}.send_back_policy`)}</p>
        </li>
      </ul>
    </>
  )
}

export default RegularStoreContentPrint
